import Loading from '../../../Components/Loading';
import { useAppSelector } from '../../../hooks';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PIMAgent = () => {
    const webViewRef = useRef(null);
    const [canGoBack, setCanGoBack] = useState<boolean>(false);
    const [src, setSrc] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const navigation = useNavigate();
    const token = useAppSelector((state) => state.auth.token);

    // useEffect(() => {
    //     const focusSub = navigation.addListener('focus', () => {
    //         console.log("SCREEN FOCUS → setting src");
    //         getPim();
    //     });

    //     const blurSub = navigation.addListener('blur', () => {
    //         console.log("SCREEN BLUR → deleting src");

    //         if (src) {
    //             setSrc(null);
    //         };
    //     });

    //     return () => {
    //         focusSub();
    //         blurSub();
    //     };

    // }, [navigation]);

    useEffect(() => {
        getPim();
    }, []);

    const getPim = async () => {
        setLoading(true);
        try {
            const baseUrl = 'https://customer.hirsch.com/agents/v2/pim';
            const res = await fetch(baseUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                }
            });
            
            if (!res.ok) throw new Error('Failed to fetch');
    
            const json = await res.json();
            // console.log('BASE JSON:', json)
            
            // if (!json.ack) {
            //     setError(json.errorMessage);
            // }

            // const oAuthRes = await fetch(json.url, {
            //     method: 'GET',
            //     credentials: 'include',
            //     redirect: 'follow'
            // });

            // console.log('oAuthRes:', oAuthRes);

            // const authUrl = oAuthRes.url;

            setSrc(json.url);
        } catch (e: any) {
            setError(e)
        } finally {
            console.log('SOURCE:', src)
            setLoading(false);
        }
    };

    return (
        <div 
            // style={styles.container}
            style={{ display: 'flex' }}
        >
            {error &&
                <div>
                    <span style={{ color: 'red', padding: 5 }}>Error: {error}</span>
                </div>
            }
            {loading || !src
            ? (<Loading />)
            : (
                <>
                    <iframe 
                        src={src}
                        title='PIM Agent'
                        style={{
                            width: '100%',
                            height: 'calc(100vh - 64px)',
                            border: 'none',
                            flex: 1,
                        }}
                    />
                </> 
            )}
        </div>
    )
};

export default PIMAgent;